/* ---------------------------------------------------------------------------
   RELATED PRODUCTS — carousel arrows

   This lives in its own file rather than inline in the section, because the
   section's markup arrives via <product-recommendations>, which fetches the
   section and writes it in with innerHTML. Scripts inserted that way never
   execute, so an inline version binds nothing and the arrows stay hidden
   forever.

   Loaded once on the page instead, it watches for a track appearing and wires
   it up whenever it does -- which also covers the cart page swapping its
   recommendations after a line is removed.
   --------------------------------------------------------------------------- */
(function () {
  const READY = 'data-related-ready';

  function pageWidth(track) {
    const card = track.firstElementChild;
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    const step = card.getBoundingClientRect().width + gap;
    if (!step) return track.clientWidth;
    /* Move by whole cards, so a card is never left half cut at the edge. */
    return step * Math.max(1, Math.floor(track.clientWidth / step));
  }

  function wire(track) {
    if (track.dataset.synRelBound === '1') return;
    track.dataset.synRelBound = '1';

    const carousel = track.closest('[data-syn-rel-carousel]');
    const section = track.closest('[id^="shopify-section-"]');
    if (!carousel) return;

    const prev = carousel.querySelector('[data-syn-rel-prev]');
    const next = carousel.querySelector('[data-syn-rel-next]');

    function sync() {
      const scrollable = track.scrollWidth - track.clientWidth > 2;
      if (section) section.setAttribute(READY, 'true');
      [prev, next].forEach((b) => { if (b) b.classList.toggle('is-visible', scrollable); });
      if (!scrollable) return;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -pageWidth(track), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: pageWidth(track), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* Card images load after the markup lands, which changes the scroll width,
       so measure again when the box actually settles. */
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    sync();
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-syn-rel-track]').forEach(wire);
  }

  scan();
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('[data-syn-rel-track]')) wire(node);
        else scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
